import { AppSettings } from '@/libs/invoke';
import store from '@/store';

async function changeSkin() {
    try {
        // const mode = 'dark';
        const mode = await AppSettings.getSkin();
        if (mode === 'dark') {
            const body = document.querySelector('body');
            Array.from(body.classList).forEach(cls => {
                if (cls.indexOf('-skin') > -1) {
                    body.classList.remove(cls);
                }
            });
            body.classList.add('black-skin');
        }
        store.commit('setSkin', mode);
    } catch (error) {
        console.log(error);
    } finally {
        console.log('1');
    }
}

changeSkin();
